import { StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  root: {
    width: '9cm',
  },
});

export { styles };
